import { gql } from '@apollo/client';

export const ASSESSMENT_FIELDS = gql`
  fragment AssessmentFields on Assessment {
    _id
    name
    infoLink
    evaluationGroupName
    introLink
    isAttendanceRequestedDefault
    reportCardsIncludeNonConcludedDefault
    retainJerseyAssignments
  }
`;

export const UPDATE_ASSESSMENT = gql`
  mutation UpdateAssessment($_id: ID!, $data: UpdateAssessmentInput!) {
    updateAssessment(_id: $_id, data: $data) {
      ...AssessmentFields
    }
  }

  ${ASSESSMENT_FIELDS}
`;

// Selects createdAt + ageGroupIds beyond the shared fragment: role filtering
// checks age-group-scoped grants, and active-assessment fallback sorts by createdAt.
export const GET_ASSESSMENTS = gql`
  query GetAssessments($companyId: ID!) {
    assessments(companyId: $companyId) {
      ...AssessmentFields
      createdAt
      ageGroupIds
    }
  }

  ${ASSESSMENT_FIELDS}
`;

// Single assessment by id — shared by every "fetch the active assessment" consumer
// so they resolve from one normalized cache entry and the selection sets can't drift.
export const GET_ASSESSMENT = gql`
  query GetAssessment($_id: ID!) {
    assessment(_id: $_id) {
      ...AssessmentFields
    }
  }

  ${ASSESSMENT_FIELDS}
`;
